import styled from "styled-components";

export const Content = styled.div`
  min-height: calc(100vh - 156.8px);
  padding-top: 7vh;
`;

export const Title = styled.h1`
  color: #0b4682;
  font-size: 22px;
  line-height: 33px;
  text-align: center;
  padding: 0 10px;

  span {
    border-bottom: 1px solid #8bc53f;
    color: #0b4682;
  }
`;

export const DeliverButton = styled.button`
  background: #8bc53f;
  border: none;
  padding: 10px 20px;
  color: #fff;
  text-transform: uppercase;
  max-width: 200px;
  border-radius: 5px;
`;

export const Controls = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 70px;

  a {
    margin-top: 30px;
    color: grey;
  }
`;

export const Text = styled.p`
  text-align: center;
  color: grey;
  font-size: 14px;
  margin-top: 10px;
`